import _ from '@/utils/lodash-optimized'
import PropTypes from 'prop-types'
import { Component } from 'react'

import { TextArea } from '../TextArea'
import { TextBox } from '../TextBox'
import './styles.scss'

const queryText = (value, textFunc) =>
  (value && textFunc && textFunc(value)) || value || ''

export class AutoComplete extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: props.value,
      query: queryText(props.value, props.textFunc),
      data: [],
      show: false
    }

    const { dataFunc } = this.props
    this.queryCount = 0
    this.queryData = _.debounce(query => {
      this.queryCount += 1
      const count = this.queryCount
      dataFunc(query).then(data => {
        if (count === this.queryCount) {
          this.setState({ data })
        }
      })
    }, props.timeout)
  }

  UNSAFE_componentWillReceiveProps (props) {
    const { value: propValue } = this.props
    if (props.value !== propValue) {
      this.setState({
        value: props.value,
        query: queryText(props.value, props.textFunc)
      })
    }
  }

  onChangeText = event => {
    const { onChangeText, freetext } = this.props
    const query = event.target.value
    this.setState({ query })
    if (freetext && onChangeText) {
      onChangeText({ freetext: query })
    }
    this.queryData(query)
  }

  onFocusText = e => {
    const { onFocus } = this.props
    const { query } = this.state
    if (onFocus) {
      onFocus(e)
    }

    this.setState({ show: true })
    this.queryData(query)
  }

  onBlurText = () => {
    const { freetext, textFunc } = this.props
    const { value, query, data } = this.state
    if (query === queryText(value, textFunc)) {
      this.handle(value)
    } else if (query.length > 0 && Array.isArray(data) && data.length === 1) {
      this.handle(data[0])
    } else if (freetext) {
      this.handle({ freetext: query })
    } else {
      this.handle(null)
    }
    this.setState({ data: [] })
  }

  handle = (value, isSubmit = false) => {
    const { textFunc, onChange, onBlur, inputPath } = this.props
    this.setState({
      value,
      query: queryText(value, textFunc),
      show: false
    })

    if (onChange) {
      onChange(value, isSubmit)
    }

    if (onBlur) {
      setTimeout(() => {
        onBlur(inputPath)
      }, 10)
    }
  }

  renderData (data, textFunc, displayFunc) {
    if (Array.isArray(data) && data.length > 0) {
      const display = displayFunc || textFunc || (d => d)
      return data.map((d, i) => (
        <button
          key={i}
          onMouseDown={() => {
            this.handle(d, true)
          }}
        >
          <li
            ref={`result-${i}`}
          >
            {display(d)}
          </li>
        </button>
      ))
    }
    if (typeof data === 'string' && data.length > 0) {
      return <li disabled>{data}</li>
    }
    return null
  }

  renderShow () {
    const { show, data } = this.state
    const { textFunc, displayFunc } = this.props
    if (show && !_.isEmpty(data)) {
      return (
        <div className='nh-results'>
          <ul className='nh-results-list'>
            {this.renderData(data, textFunc, displayFunc)}
          </ul>
        </div>
      )
    }
    return null
  }

  renderTextArea () {
    const { label, errors, style, ...rest } = this.props
    const { query } = this.state
    return (
      <div
        className='nh-autocomplete'
        style={style}
      >
        <TextArea
          {...rest}
          label={label}
          value={query}
          onChange={this.onChangeText}
          onFocus={this.onFocusText}
          onBlur={this.onBlurText}
          errors={errors}
        />
        {this.renderShow()}
      </div>
    )
  }

  renderTextBox () {
    const { label, errors, style, ...rest } = this.props
    const { query } = this.state
    return (
      <div
        className='nh-autocomplete'
        style={style}
      >
        <TextBox
          {...rest}
          name='autocomplete'
          label={label}
          value={query}
          onChange={this.onChangeText}
          onFocus={this.onFocusText}
          onBlur={this.onBlurText}
          errors={errors}
        />
        {this.renderShow()}
      </div>
    )
  }

  render () {
    const { textArea } = this.props
    return textArea ? this.renderTextArea() : this.renderTextBox()
  }
}

AutoComplete.defaultProps = {
  timeout: 500
}

AutoComplete.propTypes = {
  label: PropTypes.string.isRequired,
  dataFunc: PropTypes.func.isRequired,
  textFunc: PropTypes.func,
  displayFunc: PropTypes.func,
  freetext: PropTypes.bool,
  text: PropTypes.bool,

  value: PropTypes.any,
  onChange: PropTypes.func,
  timeout: PropTypes.number,
  errors: PropTypes.arrayOf(PropTypes.string)
}
